import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaService {

  public params = new HttpParams();

  private readonly endpoint = '/api/ocorrencias';

  constructor(
    private readonly apiService: ApiService
  ) {}

  // =========================================================
  // LISTAR OCORRÊNCIAS
  // GET /api/ocorrencias
  // =========================================================

  list(params?: any): Observable<any> {

    return this.apiService.get(
      this.endpoint,
      params
        ? new HttpParams({
            fromObject: params
          })
        : this.params
    ).pipe(
      map(response => response)
    );
  }

  // =========================================================
  // OBTER OCORRÊNCIA
  // GET /api/ocorrencias/{id}
  // =========================================================

  show(
    id: string | number
  ): Observable<any> {

    return this.apiService.get(
      `${this.endpoint}/${id}`
    ).pipe(
      map(response => response)
    );
  }

  // =========================================================
  // ELIMINAR OCORRÊNCIA
  // DELETE /api/ocorrencias/{id}
  // =========================================================

  delete(
    id: string | number
  ): Observable<any> {

    return this.apiService.delete(
      `${this.endpoint}/${id}`
    );
  }

  // =========================================================
  // CRIAR OCORRÊNCIA
  // POST /api/ocorrencias
  // =========================================================

  store(
    ocorrencia: any
  ): Observable<any> {

    return this.apiService.post(
      this.endpoint,
      ocorrencia
    );
  }

  // =========================================================
  // ATUALIZAR OCORRÊNCIA
  // PUT /api/ocorrencias/{id}
  // =========================================================

  update(
    ocorrencia: any,
    id: string | number
  ): Observable<any> {

    return this.apiService.put(
      `${this.endpoint}/${id}`,
      ocorrencia
    );
  }
}